<template>
    <div>
        <nav class="mainHeader">

            <router-link :to="{name : '로그인'}">
                <el-button type="text" @click="resetSubmit" @mouseout="resetSubmit">
                    로그인 
                </el-button>
            </router-link>

            <a> | </a>

            <!-- <router-link :to="{name : '약관동의'}"> -->
            <router-link :to="{name : '회원선택'}">
                <el-button type="text" @click="resetSubmit" @mouseout="resetSubmit">
                    회원가입 
                </el-button>
            </router-link>

            <a> | </a>
            
            <router-link :to="{name: '사이트맵정보'}">
                <el-button type="text" @click="resetSubmit" @mouseout="resetSubmit">
                    사이트맵
                </el-button>
            </router-link>
                
        </nav>
    </div>
</template>

<script>

export default {
    data() {
        return {
            isAdmin: false
        }
    },
    methods: {
        resetSubmit() {

            this.$store.firstMenu = false;
            this.$store.secondMenu = false;
            this.$store.thirdMenu = false;
            this.$store.fourthMenu = false;
            
        }
    }
}

</script>

<style scoped>
@import '@/assets/css/reset.css';
    div {
        width: 100vh;
    }

    .mainHeader {
        max-width: 1200px;
        width: 90%;
        margin: auto;
        font-size: 25px;
        text-align: right;
    }

    a {
        margin-right: 10px;
        font: normal normal 14px/20px Noto Sans KR-BOLD;
        letter-spacing: -0.35px;
        color: #4C4C4C;
    }

    .el-button {
        font: normal normal 14px/20px Noto Sans KR-BOLD;
        letter-spacing: -0.35px;
        color: #4C4C4C;
        margin-top: 2.6%;
    }

    /* hover event시 text색 바뀜 */
    .el-button:hover {
        color: #008FD2;

    }
    
    /* 반응형 웹 CSS */
    @media all and (max-width: 1200px) {

        .mainHeader {
            width: 100vw;
        }

        nav {
            float: left;
            margin-left: -2% !important;
        }
    }

    /* 1024px 태블릿 모드 */
    @media all and (max-width: 1024px) {

        .mainHeader {
            width: 99vw;
        }
    }

    /* 모바일 반응형 css 시작 */
    @media all and (max-width: 1000px) {

        .mainHeader {
            width: 98vw;
        }

    }

</style>